// extracted by mini-css-extract-plugin
export var container = "_dd-0";
export var infoIcon = "_dd-2";
export var titleRowCol = "_dd-1";